import Button from "@pathwright/ui/src/components/button/Button"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import useDidMountEffect from "@pathwright/ui/src/components/hooks/useDidMountEffect"
import withLauncher from "@pathwright/ui/src/components/launcher/withLauncher"
import Course from "@pathwright/ui/src/components/library/Course"
import compose from "lodash/flowRight"
import get from "lodash/get"
import PropTypes from "prop-types"
import styled from "styled-components"
import { getGroupUrl } from "../../utils/urls"
import { useResourceContext } from "../ResourceContext"
import withCreateRegistrationUpsertGroup from "../graphql/withCreateRegistrationUpsertGroup"
import * as PathUI from "../ui/PathUI"
import TeachPathItemControls from "./TeachPathItemControls"

const ActionArea = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  html.no-touch li:not(:hover) & .SubmitButton--default,
  html.no-touch li:not(:hover) & .Button:not(.SubmitButton) {
    visibility: hidden;
  }
`

const TeachPathResource = ({
  pathItem,
  layout,
  createRegistrationUpsertGroup,
  onLaunch
}) => {
  const resourceContext = useResourceContext()
  const toGroup = pathItem.linked_cohort
    ? {
        pathname: getGroupUrl(
          pathItem.linked_resource.slug,
          pathItem.linked_cohort.id
        ),
        state: { setResourceLaunchedFrom: true }
      }
    : {}

  // the user's linked registration (cannot depend on path.linked_registration as the path loaded for a teacher is the default path, which won't have a registration, unless the default path is master and the registration is a course editor registration of course...)
  const linkedUserRegistration = get(
    pathItem.linked_cohort,
    "user_registration"
  )

  useDidMountEffect(() => {
    // FWIW, linked_cohort should always exist at this point
    if (pathItem.linked_cohort || linkedUserRegistration) {
      onLaunch(toGroup)
    }
  }, [
    pathItem.linked_cohort && pathItem.linked_cohort.id,
    linkedUserRegistration && linkedUserRegistration.id
  ])

  return (
    <PathUI.PathResourceContainer layout={layout}>
      <Course course={pathItem.linked_resource} layout={layout} />
      <TeachPathItemControls pathItem={pathItem} inverted={layout === "grid"} />
      <ActionArea>
        {/* upsert group if no group + ensure registration if user is registered in collection but not registered in group */}
        {pathItem.linked_cohort &&
        (!resourceContext.registration || linkedUserRegistration) ? (
          <Button brand styleType="primary" onClick={() => onLaunch(toGroup)}>
            View
          </Button>
        ) : (
          <SubmitButton
            brand
            styleType="primary"
            onClick={() =>
              // Indicate to backend that we'd like to register the user to the cohort.
              // The backend will use the user's role in the collection cohort.
              // If no registration is found, the user will not be registered.
              createRegistrationUpsertGroup(true /* createrRegistration */)
            }
          >
            View
          </SubmitButton>
        )}
      </ActionArea>
    </PathUI.PathResourceContainer>
  )
}

TeachPathResource.displayName = "TeachPathResource"

TeachPathResource.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default compose(
  withLauncher,
  withCreateRegistrationUpsertGroup
)(TeachPathResource)
